import { Form, ButtonToolbar, Button } from 'react-bootstrap';
import { Formik } from 'formik';

import { getMeasureInputField } from '../../shared/inputs/inputHelpers';
import TextField from '../../shared/inputs/formik/TextField';

import EditActions from '../../shared/EditActions';
import ActiveMeasuresErrorMessage from '../../clients/measures/ActiveMeasuresErrorMessage';
import { Spinner } from 'react-bootstrap';

import ClientSearch from '../../clients/ClientSearch';

function EditMeasureData({
    assessmentUsed,
    data,
    measureCount,
    totalMeasures,
    showSkipButton,
    isClientMeasure,
    isLoading,
    isExternalForm,
    selectedClient,
    handleCancelClick,
    handleSkipClick,
    handlePrevClick,
    handleFormSaveAndSubmit,
    handleSearchSelect,
    errorMessage }) {
    const showClientLookup = isClientMeasure || false;

    const scoreDateFieldName = 'scoreDate';
    const firstNameFieldName = "firstName";
    const lastNameFieldName = "lastName";
    const dobFieldName = "dateOfBirth";

    const today = new Date().toISOString().split('T')[0];
    let initMeasureValues = { scoreDate: today };

    const toInputDateFormat = (dateStr) => {
        if (dateStr.includes('/')) {
            const [month, day, year] = dateStr.split('/');
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
        } else {
            return dateStr;
        }

    };

    if (data?.id > 0) {
        // this is the stored data for an existing record
        JSON.parse(data.measureData).values.forEach((val) => (initMeasureValues[val.fieldName] = val.fieldValue));
    }

    // build the initial values for use in formik, honoring any defaultValues set
    let initialValues = { ...data };
    data?.fields?.forEach((field) => {
        initialValues[field.name] = field.defaultValue !== null ? field.defaultValue : '';
    });

    initialValues = { ...initialValues, ...initMeasureValues }; // set initial values from stored values

    return (
        <>
            <ActiveMeasuresErrorMessage errorMessage={errorMessage} />
            <Formik
                onSubmit={(values) => handleFormSaveAndSubmit(values)}
                initialValues={initialValues}
                enableReinitialize>
                {({ handleSubmit, handleChange, handleBlur, values, touched, errors }) => (
                    <Form onSubmit={handleSubmit} className="my-3">

                        {showClientLookup &&
                            isExternalForm ?
                            <>

                                <TextField
                                    name={firstNameFieldName}
                                    label="First Name"
                                    required={true}

                                    value={values?.[firstNameFieldName]}
                                    error={errors[firstNameFieldName]}
                                    touched={touched[firstNameFieldName]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    errorMessage={errors[firstNameFieldName]}
                                    isInvalid={touched[firstNameFieldName] && !!errors[firstNameFieldName]}
                                    disabled={values?.[firstNameFieldName] && measureCount !== 1}
                                />

                                <TextField
                                    name={lastNameFieldName}
                                    label="Last Name"
                                    required={true}

                                    value={values?.[lastNameFieldName]}
                                    error={errors[lastNameFieldName]}
                                    touched={touched[lastNameFieldName]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    errorMessage={errors[lastNameFieldName]}
                                    isInvalid={touched[lastNameFieldName] && !!errors[lastNameFieldName]}
                                    disabled={values?.[lastNameFieldName] && measureCount !== 1}
                                />

                                <TextField
                                    name={dobFieldName}
                                    label="Date of Birth"
                                    type="date"
                                    as="date"
                                    required={true}

                                    value={values?.[dobFieldName] ? new Date(toInputDateFormat(values[dobFieldName])).toISOString().split('T')[0] : ""}
                                    error={errors[dobFieldName]}
                                    touched={touched[dobFieldName]}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    errorMessage={errors[dobFieldName]}
                                    isInvalid={touched[dobFieldName] && !!errors[dobFieldName]}
                                    disabled={values?.[dobFieldName] && measureCount !== 1}
                                />

                            </> : showClientLookup &&
                            <>
                                {measureCount === 1 &&
                                    <ClientSearch handleSearchSelect={handleSearchSelect} />
                                }
                                <p className='mt-3'><strong> Selected client: </strong> {selectedClient ? selectedClient?.label : "Select a client."}</p>
                                {assessmentUsed && (
                                    <p>
                                        <strong>Assessment Used:</strong> {assessmentUsed}
                                    </p>
                                )}
                            </>
                        }

                        <TextField
                            name={scoreDateFieldName}
                            label="Measure Date"
                            type="date"
                            as="date"
                            required={true}
                            value={values?.[scoreDateFieldName]}
                            error={errors[scoreDateFieldName]}
                            touched={touched[scoreDateFieldName]}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            errorMessage={errors[scoreDateFieldName]}
                            isInvalid={touched[scoreDateFieldName] && !!errors[scoreDateFieldName]} />

                        {data?.fields?.map((field) => {
                            return getMeasureInputField(field, {
                                value: values?.[field.name],
                                error: errors[field.name], // for radio inputs
                                touched: touched[field.name], // for radio inputs
                                onChange: handleChange,
                                onBlur: handleBlur,
                                errorMessage: errors[field.name], // for our custom Inputs
                                isInvalid: touched[field.name] && !!errors[field.name],
                            });
                        })}

                        <p className="d-flex justify-content-center">
                            {measureCount}/{totalMeasures}
                        </p>

                        <EditActions>
                            <ButtonToolbar className="d-flex justify-content-end">
                                <Button variant="outline-danger" onClick={handleCancelClick} disabled={isLoading}>
                                    Cancel
                                </Button>
                                {measureCount !== 1 && (
                                    <Button variant="secondary" onClick={handlePrevClick} disabled={isLoading}>
                                        Prev
                                    </Button>
                                )}
                                {showSkipButton && (
                                    <Button variant="outline-primary" onClick={handleSkipClick} disabled={isLoading}>
                                        Skip
                                    </Button>
                                )}
                                <Button variant="primary" type="submit" disabled={isLoading}>
                                    {
                                        isLoading ?
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                            :
                                            measureCount !== totalMeasures ? 'Next/Save' : 'Submit'
                                    }
                                </Button>
                            </ButtonToolbar>
                        </EditActions>
                    </Form>
                )}
            </Formik>
        </>
    );
}

export default EditMeasureData;
